export default "__VITE_ASSET__CelMVpMb__"